(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('InputPrConfirmController',InputPrConfirmController);

    InputPrConfirmController.$inject = ['$uibModalInstance','toggleValue'];

    function InputPrConfirmController($uibModalInstance,  toggleValue ) {
        var vm = this;
        vm.confirm = confirm;
        if(toggleValue == true){
        	vm.toggleValue ='mở'
        }else{
        	vm.toggleValue ='khóa'
        }
        vm.clear = clear;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirm(numChoose) {
        	$uibModalInstance.close(numChoose);
        }
    }
})();
